'use client'
import { Image } from '@/components'
import useFancybox from '@/components/common/fancybox'
import { Grid } from '@mui/material'
import Link from 'next/link'

type Props = {
  images?: string[]
}

export const ListImageDescription = ({ images }: Props) => {
  const [fancyboxRef] = useFancybox()

  if (!images || images.length === 0) {
    return null
  }

  return (
    <div ref={fancyboxRef}>
      <Grid
        container
        spacing={{
          xs: 1,
          md: 2,
        }}
      >
        {images?.map((item, index) => {
          if (!item) {
            return null
          }
          return (
            <Grid
              size={{
                xs: 6,
                sm: 6,
                md: 4,
              }}
              key={index}
            >
              <Link
                href={item}
                data-fancybox="gallery-description"
                data-caption={`Description Image ${index + 1}`}
              >
                <Image
                  key={index}
                  src={item}
                  ratio={'3/4'}
                  alt={`description-${index + 1}`}
                  sx={{ width: '100%', borderRadius: 2 }}
                />
              </Link>
            </Grid>
          )
        })}
      </Grid>
    </div>
  )
}
